/**
 * Created by anthony on 7/3/14.
 */


var familyTaxModel = angular.module('familyTaxModel', []);
familyTaxModel.factory('FamilyTaxModelFactory', function(ApplicationService, AbstractModelService, FamilyModelFactory){
    var familyTaxModel = function(){
        this.endpoint = "/FamilyTax";
        this.dataProperty = "familyTax";
        this.primaryKey = "familyID";
    }
    familyTaxModel.prototype = new FamilyModelFactory();
    familyTaxModel.prototype.parent = FamilyModelFactory.prototype;

    familyTaxModel.prototype.resend = function(id, data, instance)
    {
        return AbstractModelService.post("/api/family/" + id + "/taxEmails", data, instance);
    }
    familyTaxModel.prototype.put = function(id, data, instance)
    {
        return AbstractModelService.put("/api/family/" + data.familyID + "/FamilyTax", data, instance);
    }
    return familyTaxModel;
});

familyTaxModel.service('FamilyTaxModelService', function(FamilyTaxModelFactory){
    var familyTaxModel = new FamilyTaxModelFactory();
    return familyTaxModel;
});